/**
 * Khớp đường dẫn với bảng route — tách khỏi main.js để test được.
 *
 * main.js gắn chặt vào DOM và `location`, nên phần quyết định "đường dẫn này đi
 * đâu" trước đây không có test nào. Đó chính là chỗ lọt lỗi: bảng route không có
 * mục nào cho `/`, nên người dùng đã đăng nhập mở thẳng URL trần (bookmark, gõ
 * tay, hoặc refresh sau khi hash bị xoá) rơi vào màn hình "Không tìm thấy trang".
 * Chỉ luồng bấm nút Đăng nhập mới đúng, vì nó tự đặt hash.
 */

/** Nơi đưa người dùng tới khi họ chưa nói muốn xem gì (URL trần, sau đăng nhập). */
export const DEFAULT_PATH = '/households';

/**
 * @param {string} path - phần đường dẫn của hash, ví dụ '/submissions/abc'
 * @param {Array<{re: RegExp}>} routes
 * @returns {{route: object, id: string|undefined} | null}
 */
export function matchRoute(path, routes) {
  for (const route of routes) {
    const m = path.match(route.re);
    if (m) return { route, id: m[1] };
  }
  return null;
}

/**
 * Đường dẫn cần chuyển hướng trước khi khớp route, hoặc `null` nếu đi tiếp bình thường.
 *
 * Gom cả ba quyết định vào một chỗ để chúng không mâu thuẫn nhau: chưa đăng nhập
 * thì về màn đăng nhập, đã đăng nhập rồi thì không quay lại đó nữa, và đường dẫn
 * rỗng thì đi tới trang mặc định thay vì báo không tìm thấy.
 *
 * @param {string} path
 * @param {boolean} loggedIn
 * @returns {string|null}
 */
export function redirectFor(path, loggedIn) {
  if (!loggedIn) return path === '/login' ? null : '/login';
  if (path === '/login') return DEFAULT_PATH;
  // '/' là URL trần; '' phòng khi hash rỗng lọt qua được parseHash.
  if (path === '/' || path === '') return DEFAULT_PATH;
  return null;
}
